import { reaction } from 'mobx';
import storeCurrentFilters from '../store/filters';
import { findShops } from '../api';
import storeStores from '../store/stores';

function defaultReactionHandler(filter, filterLabel) {
  const changedFilters = !filter.length
    ? undefined
    : filter.map(entry => {
      return entry.id;
    });
  findShops(
    Object.assign(
      { [filterLabel]: changedFilters },
      storeCurrentFilters.getFormattedFilters(),
    ),
  ).then(shops => {
    storeStores.setGlobalStoresList(shops);
  });
}

export function setFiltersListeners() {
  reaction(
    () => storeCurrentFilters.currentFilters.type_of_sales.length,
    () => {
      const filter = storeCurrentFilters.currentFilters.type_of_sales;
      defaultReactionHandler(filter, 'type_of_sales');
    },
  );
  reaction(
    () => storeCurrentFilters.currentFilters.type_of_store,
    filter => {
      defaultReactionHandler(filter, 'type_of_store');
    },
  );
  reaction(
    () => storeCurrentFilters.currentFilters.subtype_of_store,
    filter => {
      defaultReactionHandler(filter, 'subtype_of_store');
    },
  );
  reaction(
    () => storeCurrentFilters.currentFilters.type_of_location.length,
    () => {
      const filter = storeCurrentFilters.currentFilters.type_of_location;
      defaultReactionHandler(filter, 'type_of_location');
    },
  );
}
